module.exports = __webpack_public_path__ + "img/poor.c466d647.svg";